import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Courses } from '../data/courses'

const initialState = {
    allCourses: Courses,
    myCourses: Courses.filter(course => course.isMine),
}
const coursesSlice = createSlice({
    name: 'courses',
    initialState,
    reducers: {
        setCourses: (state, action) => {
            state.allCourses = action.payload
            state.myCourses = action.payload.filter(course => course.isMine)
        },
    },
})

export const { setCourses} = coursesSlice.actions
export default coursesSlice.reducer